import { Button, Headings, Paragraph } from '@sentara-health/optimahealth_web';

interface Disclaimer {
  superScript?: React.ReactElement;
  style: string;
  text: string;
}

interface VirtualVisitModalBoxProps {
  logoImage?: React.ReactElement | null;
  title: string;
  subtitle?: string;
  costInfo?: string | null;
  badgeImage: React.ReactElement;
  content: React.ReactNode;
  disclaimers?: Disclaimer[];
  buttonLabel: string;
  buttonTestId: string;
  minHeight: string;
  buttonOnClick: () => void;
  costValue?: string;
  superTextOne?: string;
  superTextTwo?: string;
  superTextThree?: string;
  displayBlock?: boolean;
  deductibleText?: string | null;
  deductibleBlock?: boolean;
}

function VirtualVisitModalBox({
  logoImage,
  title,
  subtitle,
  costInfo,
  badgeImage,
  content,
  disclaimers,
  buttonLabel,
  buttonTestId,
  minHeight,
  buttonOnClick,
  superTextOne,
  superTextTwo,
  superTextThree,
  costValue,
  displayBlock = false,
  deductibleText,
  deductibleBlock = false,
}: Readonly<VirtualVisitModalBoxProps>) {
  return (
    <div className="d-flex flex-column justify-content-between">
      {logoImage ? (
        <span className="d-flex flex-column justify-content-between virtual-visit-icon-style pt-3">
          {logoImage}
        </span>
      ) : null}
      <div className="p-md-4 pb-1 p-2">
        <div style={{ minHeight: `${minHeight}px` }}>
          <Headings
            level={3}
            text={`${title}`}
            variant={'semiBold'}
            className="d-inline-block"
          />
          {superTextOne ? <sup className="ms-1">{superTextOne}</sup> : null}
          <div>
            {subtitle ? (
              <Headings
                level={5}
                text={subtitle}
                variant="medium"
                className="d-inline-block"
              />
            ) : null}
            {costInfo ? (
              <Headings
                level={5}
                text={costInfo}
                variant="regular"
                className={!displayBlock ? 'd-inline-block my-0' : ''}
              />
            ) : null}
            {costValue ? (
              <>
                <span className="ps-2">{costValue}</span>
                {superTextTwo ? (
                  <sup className="ms-1">{superTextTwo}</sup>
                ) : null}
              </>
            ) : null}
            {deductibleBlock ? (
              <Paragraph
                text ={
                  deductibleText
                }
                variant="medium"
                level={2}
                className="text-left my-0"
                />
            ) : null}
          </div>
          
          <span className="d-inline-block my-2">{badgeImage}</span>
          <Paragraph
            text={
              <>
                {content}
                {superTextThree ? <sup>{superTextThree}</sup> : null}
              </>
            }
            variant="regular"
            className="text-left"
          />
        </div>
        <Button
          className="btn-md-height mt-1 text-nowrap text-truncate"
          dataTestId={buttonTestId}
          variant='primary_btn'
          onClick={() => {
            buttonOnClick();
          }}
         >{buttonLabel}</Button>
        <ul className="labels-list">
          {disclaimers && disclaimers.length > 0
            ? disclaimers.map((label, index) => (
                <li key={index} className={label.style}>
                  {label.superScript}
                  {''}
                  {label.text}
                </li>
              ))
            : null}
        </ul>
      </div>
    </div>
  );
}

export default VirtualVisitModalBox;
